import ReactGA from 'react-ga';
ReactGA.initialize('UA-104943870-1');

exports.onRouteUpdate = (state, page, pages) => {
  ReactGA.pageview(state.location.pathname);
};


// WEBPACK FOOTER //
// ./gatsby-browser.js